import { createContext } from 'react';

type SessionContextProps = {
  validRange: {
    from: Date;
    to: Date;
  };
  selectedRange: {
    from: Date;
    to: Date;
  };
  selectRange: (newFrom: Date, newTo: Date) => void;
  visibleRange: {
    from: Date;
    to: Date;
  };
  selectVisibleRange: (newFrom: Date, newTo: Date) => void;
};

export const GraphSessionRangeContext = createContext<SessionContextProps>(
  {} as SessionContextProps,
);
